import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchSkills {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  pageSize?: number;
  search?: string;
  fields?: string[];
}
export const useFetchSkills = (params: IUseFetchSkills) => {
  const fetchSkills = async ({ pageParam = 1 }) => {
    const { relations: skillsRelations, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (skillsRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    queryString.append('limit', String(params.pageSize));
    try {
      return await get(`${API_URLS.SKILLS_LIST}?${queryString.toString()}`);
    } catch (error) {
      console.error('Error fetching skills:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch skills'); // Force error throwing
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['skills-list', params],
    queryFn: fetchSkills,
    getNextPageParam: (lastPage, allPages) => {
      const totalPageCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedPageCount = allPages.flatMap((page) => page.data).length;
      return fetchedPageCount < totalPageCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
